const GROUPS = {
  ADMIN: 'ADMIN',
  COMPANY_OWNER: 'COMPANY_OWNER',
  MANAGER: 'MANAGER',
  AUTO_REMEDIATION_MANAGER: 'AUTO_REMEDIATION_MANAGER',
  USER: 'USER',
}

export { GROUPS }
